import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Security from "./pages/Security";
import TitleHero from "./pages/pitch/01_TitleHero";
import Problem from "./pages/pitch/02_Problem";
import Solution from "./pages/pitch/03_Solution";
import HowItWorks from "./pages/pitch/04_HowItWorks";
import MarketOpportunity from "./pages/pitch/05_MarketOpportunity";
import TractionMilestones from "./pages/pitch/06_TractionMilestones";
import BusinessModel from "./pages/pitch/07_BusinessModel";
import Competition from "./pages/pitch/08_Competition";
import ImpactSDG from "./pages/pitch/09_ImpactSDG";
import TheAsk from "./pages/pitch/10_TheAsk";
import ContactSales from "./pages/ContactSales";
import OnboardingTrialPage from "./pages/OnboardingTrialPage";

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<LandingPage />} />
				<Route path="/about-us" element={<AboutUs />} />
				<Route path="/contact-us" element={<ContactUs />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/security" element={<Security />} />
				<Route path="contact-sales" element={<ContactSales />} />
				<Route path="start" element={<OnboardingTrialPage />} />

				<Route path="pitch">
					<Route index element={<TitleHero />} />
					<Route path="problem" element={<Problem />} />
					<Route path="solution" element={<Solution />} />
					<Route path="howitworks" element={<HowItWorks />} />
					<Route path="market-opportunity" element={<MarketOpportunity />} />
					<Route path="traction-milestones" element={<TractionMilestones />} />
					<Route path="business-model" element={<BusinessModel />} />
					<Route path="competition" element={<Competition />} />
					<Route path="impact-sdg" element={<ImpactSDG />} />
					<Route path="the-ask" element={<TheAsk />} />
				</Route>
			</Routes>
		</Router>
	)
}

export default App;